interface IParams {
  price: number;
  initialPayment: number;
  rate: number;
  years: number;
}

/**
 * Формула для расчет ежемесячного платежа взята отсюда
 * https://mortgage-calculator.ru/%D1%84%D0%BE%D1%80%D0%BC%D1%83%D0%BB%D0%B0-%D1%80%D0%B0%D1%81%D1%87%D0%B5%D1%82%D0%B0-%D0%B8%D0%BF%D0%BE%D1%82%D0%B5%D0%BA%D0%B8/
 */
export function calculateMonthlyPayment({ price, initialPayment, rate, years }: IParams) {
  const monthlyRate = rate / 12 / 100;
  const commonRate = Math.pow(monthlyRate + 1, years * 12);
  const creditSum = price - initialPayment;

  const monthlyPayment = Math.round((creditSum * monthlyRate * commonRate) / (commonRate - 1));

  return monthlyPayment > 0 ? monthlyPayment : 0;
}
